import React from 'react';
import { withRouter } from 'react-router-dom';

import './construct.less';

import Logo from './1.png';

const Construct = () => {
  return (
    <section className={'cdo-section cdo-section-construct'}>
      <div className={'container'}>
        <img src={Logo} alt={'logo'} className={'logo'} />
        <h1 className={'title'}>Carreras de obstáculos</h1>
        <section>
          <p>Lo sentimos! :(</p>
          <p>En estos momentos estamos rehaciendo la web</p>
          <p>En breves la volverá a tener disponible y podrá disfrutar de un</p>
          <h2>Calendario de carreras de obstáculos 2020</h2>
          <p>y más cositas que estamos preparando!</p>
        </section>
        <section>
          <p>
            Para más información, no dude en ponerse en contacto con nosotros:{' '}
          </p>
          <p>
            <a href="mailto:info@carrerasdeobstaculos.com">
              info@carrerasdeobstaculos.com
            </a>
          </p>
          <p>
            <a href="https://www.instagram.com/carrerasdeobstaculos/">
              Instagram
            </a>
          </p>
          <p>
            <a href="https://www.facebook.com/carrerasdobstaculos/">Facebook</a>
          </p>
          <p>
            <a href="https://twitter.com/ObstaculosRaces">Twitter</a>
          </p>
        </section>
      </div>
    </section>
  );
};

export default Construct;
